<template>
  <l-map
      :center="Coordinates"
      :zoom="zoom"
      class="map md:h-128 bg-white dark:bg-slate-800 shadow-lg ring-1 ring-black/5 rounded-xl flex flex-col divide-y dark:divide-slate-200/5 drop-shadow-xl w-full md:w-9/12"
      ref="map"
      @update:zoom="zoomUpdated"
      @update:center="centerUpdated"
  >
    <l-tile-layer :url="url" />
    <l-marker v-for="Playground in Playgrounds"
              :key="Playground.id"
              :interactive="true"
              :name="Playground.name"
              :lat-lng="Playground.location.coordinates"
              @ready="markerReady"
              @click="centerOnMarker(Playground)"
              :ref="'marker-' + Playground.id"
    >
      <l-tooltip>{{Playground.name}}</l-tooltip>
      <l-popup>
        <h3>{{Playground.name}}</h3>
        <div>
          Plus Code: {{Playground.location.plusCode}}<br/>
          <a :href="Playground.googleURL">More on Google</a>
        </div>
      </l-popup>
    </l-marker>
  </l-map>
</template>


<script>
import { LMap, LTileLayer, LMarker, LTooltip, LPopup } from '@vue-leaflet/vue-leaflet';
import 'leaflet/dist/leaflet.css';

export default {
  props: {
    Playgrounds: Object,
    Coordinates: Array,
    selectedPlayground: Object,
    mapZoom: Number,
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LPopup
  },
  data () {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      center: this.Coordinates,
      zoom: 10,
      markerRefs: {}
    }
  },
  watch: {
    Coordinates(newCoords) {
      // Use Leaflet's native setView for proper centering
      this.$nextTick(() => {
        if (this.$refs.map && this.$refs.map.leafletObject) {
          const map = this.$refs.map.leafletObject;
          const zoomLevel = (!this.mapZoom || (this.mapZoom === 10 && this.mapZoom !== 15)) ? 12 : this.mapZoom;
          map.setView(newCoords, zoomLevel);
        }
      });
      this.center = newCoords;
    },
    selectedPlayground(newPlayground) {
      if (newPlayground) {
        this.closeAllPopups();
        this.openPlaygroundPopup(newPlayground);
      }
    },
    mapZoom(newZoom) {
      if (newZoom && newZoom !== this.zoom) {
        this.zoom = newZoom;
      }
    }
  },
  methods: {
    zoomUpdated (zoom) {
      this.zoom = zoom;
      // console.log('Zoom updated');
      // console.log(this.markers);
    },
    centerUpdated (center) {
      console.log('Center:');
      console.log(center);
      let coords = [center.lat, center.lng];
      this.$emit('recentered', coords);
    },
    openPopup (layer) {
      layer.openPopup()
    },
    centerOnMarker(playground) {
      // Use Leaflet's native setView method for proper centering
      this.$nextTick(() => {
        if (this.$refs.map && this.$refs.map.leafletObject) {
          const map = this.$refs.map.leafletObject;
          // First center at current zoom, then zoom in
          map.setView(playground.location.coordinates, this.zoom);
          setTimeout(() => {
            map.setView(playground.location.coordinates, 15);
          }, 100);
        }
      });
      
      this.$emit('recentered', playground.location.coordinates);
      this.$emit('playground-selected', playground);
    },
    markerReady(marker) {
      const playground = this.Playgrounds.find(p => 
        p.location.coordinates[0] === marker.getLatLng().lat && 
        p.location.coordinates[1] === marker.getLatLng().lng
      );
      if (playground) {
        this.markerRefs[playground.id] = marker;
      }
    },
    closeAllPopups() {
      Object.values(this.markerRefs).forEach(marker => {
        if (marker.closePopup) {
          marker.closePopup();
        }
      });
    },
    openPlaygroundPopup(playground) {
      const marker = this.markerRefs[playground.id];
      if (marker && marker.openPopup) {
        marker.openPopup();
      }
    }
  }
}
</script>

<style>
.map {
  position: absolute;
  overflow: hidden;
  width: 100% !important;
}

@media (min-width: 768px) {
  .map {
    width: 75% !important;
  }
}
</style>